import { Button } from '@britishcouncil/react-admin';
import styled from '@emotion/styled';
import { Segment } from 'semantic-ui-react';

interface FooterProps {
  isModified: boolean;
  isLoadingButtons: boolean;
  onDiscard: () => void;
  onSave: () => void;
}

export const Footer = ({ isModified, isLoadingButtons, onDiscard, onSave }: FooterProps) => {
  return (
    <S.Footer>
      {isModified && (
        <Button compact color="grey" type="reset" disabled={isLoadingButtons} onClick={onDiscard}>
          Discard
        </Button>
      )}
      {isModified && (
        <Button
          compact
          color="green"
          type="submit"
          onClick={onSave}
          loading={isLoadingButtons}
          disabled={isLoadingButtons}
        >
          Save
        </Button>
      )}
    </S.Footer>
  );
};

const S = {
  Footer: styled(Segment)`
    &.ui.segment {
      display: flex;
      justify-content: space-between;
      margin: unset;
      border-radius: unset;
    }
  `,
};
